import React, { useState, useEffect } from "react";
import ParticipantProfileImage from "../AccountProfilePhoto";
import ParticipantProfilePictureUpload from "../AccountProfilePhotoUploadComponents/ParticipantProfilePictureUpload";
import "./UploadAndViewProfilePhoto.css";
import apiClient from "../../../../services/apiClient";
import config from "../../../../config";

const BASE_API = config.API_BASE_URL;

interface ProfileContainerProps {
  selectedAccountProfileIdInt: number;
  account_profile_image_url?: string;
}

const UploadAndViewAccountProfilePhoto: React.FC<ProfileContainerProps> = ({
  selectedAccountProfileIdInt,
  account_profile_image_url = null,
}) => {
  const [profilePictureUrl, setProfilePictureUrl] = useState<string | null>(
    account_profile_image_url || null
  );

  useEffect(() => {
    if (!account_profile_image_url && selectedAccountProfileIdInt) {
      const fetchProfilePicture = async () => {
        try {
          const response = await apiClient.get(
            `${BASE_API}account_profiles/${selectedAccountProfileIdInt}/get_photo/`
          );
          if (response.status === 200) {
            setProfilePictureUrl(response.data.profile_image_url);
          }
        } catch (error) {
          console.error("Failed to fetch profile picture", error);
        }
      };
      fetchProfilePicture();
    }
  }, [selectedAccountProfileIdInt, account_profile_image_url]);

  return (
    <div className="account-profile-container">
      <div className="account-profile-card">
        <div className="upload-and-preview">
          <div className="upload-section">
            <ParticipantProfilePictureUpload
              selectedAccountProfileIdInt={selectedAccountProfileIdInt}
              setProfilePictureUrl={setProfilePictureUrl}
            />
          </div>
          <div className="preview-section">
            <ParticipantProfileImage
              account_profile_image_url={profilePictureUrl}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default UploadAndViewAccountProfilePhoto;
